module.exports = __webpack_public_path__ + "assets/img/record.16fa3cec.png";